import ConfirmDeleteModal from "./ConfirmDeleteModal";

const DeleteModal = ({
  open,
  onClose,
  onLogout,
  loading,
  topHeading,
  description,
  subDescription,
}) => {
  const title = description || topHeading || "Are you sure you want to delete this item?";
  const detail = subDescription || "This action cannot be undone.";

  return (
    <ConfirmDeleteModal
      show={open}
      onClose={onClose}
      onConfirm={onLogout}
      loading={loading}
      title={title}
      description={detail}
      confirmText="Delete"
      cancelText="Cancel"
    />
  );
};

export default DeleteModal;
